var _path, _g, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.1547C14.2376 0.440169 15.7624 0.440169 17 1.1547L25.5574 6.0953C26.795 6.80983 27.5574 8.13034 27.5574 9.5594V19.4406C27.5574 20.8697 26.795 22.1902 25.5574 22.9047L17 27.8453C15.7624 28.5598 14.2376 28.5598 13 27.8453L4.44263 22.9047C3.20503 22.1902 2.44263 20.8697 2.44263 19.4406V9.5594C2.44263 8.13034 3.20503 6.80983 4.44263 6.0953L13 1.1547Z",
    fill: "#0090F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4213 14.2025C23.4213 14.2566 23.4207 14.31 23.4193 14.3627C24.124 15.121 24.6351 16.3477 24.6351 17.4051C24.6351 18.7095 23.8573 19.2624 22.8977 18.64C22.8578 18.6141 22.8181 18.5865 22.7788 18.5574L20.1712 16.8659C20.0821 16.8173 19.992 16.7635 19.9012 16.7046C19.8104 16.6457 19.7203 16.5826 19.6312 16.5156L15.6615 13.9405C15.5894 13.9028 15.5164 13.86 15.4426 13.8122C14.1465 12.9714 13.0958 10.8615 13.0958 9.09949C13.0958 7.33751 14.1465 6.5907 15.4426 7.43144C15.8241 7.67893 16.1843 8.0364 16.5028 8.4626C16.9076 6.68941 18.2757 6.07911 19.9012 7.13354C21.8453 8.39466 23.4213 11.5596 23.4213 14.2025Z",
    fill: "url(#paint0_linear_2488_142379)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6285 16.9213C19.6285 16.9756 19.6278 17.0292 19.6265 17.0822C20.3308 17.8406 20.8415 19.0668 20.8415 20.1238C20.8415 21.4283 20.0637 21.9812 19.1042 21.3587C19.0632 21.3321 19.0225 21.3038 18.9822 21.2739L16.3766 19.5837C16.2881 19.5353 16.1986 19.4819 16.1084 19.4234C16.0181 19.3648 15.9286 19.3022 15.8401 19.2356L11.8682 16.6591C11.7962 16.6215 11.7232 16.5788 11.6495 16.5309C10.3534 15.6902 9.30273 13.5802 9.30273 11.8182C9.30273 10.0563 10.3534 9.30945 11.6495 10.1502C12.0311 10.3977 12.3914 10.7553 12.7099 11.1816C13.1146 9.40821 14.4828 8.79781 16.1084 9.85229C18.0525 11.1134 19.6285 14.2783 19.6285 16.9213Z",
    fill: "url(#paint1_linear_2488_142379)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.357 19.7197C15.357 19.7738 15.3564 19.8273 15.3551 19.8802C16.0596 20.6385 16.5706 21.865 16.5706 22.9223C16.5706 24.2267 15.7928 24.7796 14.8332 24.1572C14.7926 24.1308 14.7522 24.1028 14.7123 24.0731L12.1069 22.383C12.0178 22.3344 11.9278 22.2807 11.8369 22.2218C11.7461 22.1628 11.6561 22.0998 11.567 22.0328L7.59856 19.4585C7.52596 19.4206 7.4524 19.3776 7.37804 19.3294C6.08197 18.4886 5.0313 16.3787 5.0313 14.6167C5.0313 12.8547 6.08197 12.1079 7.37804 12.9486C7.75963 13.1962 8.11995 13.5537 8.43844 13.98C8.84316 12.2066 10.2114 11.5962 11.8369 12.6507C13.781 13.9118 15.357 17.0767 15.357 19.7197Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2488_142379",
    x1: 24.4737,
    y1: 8.60937,
    x2: 12.8032,
    y2: 5.58744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2488_142379",
    x1: 20.6803,
    y1: 11.3278,
    x2: 9.01022,
    y2: 8.30614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E2FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCube);
export default __webpack_public_path__ + "static/media/logo-cube.18029c8e7a3a38571cb1396ef8abe531.svg";
export { ForwardRef as ReactComponent };